import { ServiceSpecification } from '@service_specification/specification_commonjs/stailer_service_specification/v1/service_specification_pb'

// パートナー設定のアカウントに関するFeatureFlagsを作成します。
export function createPartnerConfigFeatureFlagsAccountPart(spec: ServiceSpecification) {
  return {
    get enableBusinessCustomerFeature(): boolean {
      return spec.account?.businessCustomer.case === 'enableBusinessCustomer'
    },
    get useExternalIdAuthentication(): boolean {
      return spec.account?.authentication.case === 'externalIdAuthentication'
    },
  }
}
